import { Header, withLayout } from '@/components';
import { CompanyOverview } from '@/components/company/CompanyOverview';
import { NextPage } from 'next';
import { NextSeo } from 'next-seo';

const Page: NextPage = () => {
  return withLayout(
    <>
      <NextSeo title="会社概要" noindex nofollow />
      <Header />
      <CompanyOverview />
    </>,
  );
};

export default Page;
